"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _immutable = require("immutable");

var _draftExtend = require("draft-extend");

var _constants = require("composer-plugins/lib/constants");

var _draftHelpers = require("composer-plugins/lib/draftHelpers");

var _transformPropertiesForQuestions = _interopRequireDefault(require("composer-plugins/utils/transformPropertiesForQuestions"));

var _SubmitQuestionBlock = _interopRequireDefault(require("composer-plugins/plugins/questionAndAnswer/entityComponents/SubmitQuestionBlock"));

var _QuestionAndAnswerNote = _interopRequireDefault(require("composer-plugins/plugins/questionAndAnswer/QuestionAndAnswerNote"));

var _QuestionEntityRecord = _interopRequireDefault(require("./questionAndAnswer/QuestionEntityRecord"));

var BLOCK_TYPE = 'atomic';
var DISPLAY_NAME = 'QuestionAndAnswer';
var ENTITY_KEY = _constants.ENTITY_TYPES.questionAndAnswer;

var emptyFunction = function emptyFunction() {
  return null;
};

var _default = function _default() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _options$props = options.props,
      _options$props$associ = _options$props.associations,
      associations = _options$props$associ === void 0 ? (0, _immutable.Map)() : _options$props$associ,
      _options$props$enable = _options$props.enabledAssociations,
      enabledAssociations = _options$props$enable === void 0 ? (0, _immutable.Set)() : _options$props$enable,
      submission = _options$props.submission,
      questionsMap = _options$props.questionsMap,
      rawProperties = _options$props.properties,
      sourceObjectType = _options$props.sourceObjectType,
      sourceObject = _options$props.sourceObject,
      _options$props$onObje = _options$props.onObjectPropertyChanged,
      onObjectPropertyChanged = _options$props$onObje === void 0 ? emptyFunction : _options$props$onObje,
      _options$props$onSubm = _options$props.onSubmissionChanged,
      onSubmissionChanged = _options$props$onSubm === void 0 ? emptyFunction : _options$props$onSubm,
      _options$props$getQue = _options$props.getQuestionAndAnswerEnabled,
      getQuestionAndAnswerEnabled = _options$props$getQue === void 0 ? function () {
    return true;
  } : _options$props$getQue;
  var properties = (0, _transformPropertiesForQuestions.default)(rawProperties);

  var blockRendererFn = function blockRendererFn(_ref) {
    var props = _ref.props;
    return function (currentBlock) {
      if (!(0, _draftHelpers.isCorrectBlockTypeAndSize)(currentBlock, BLOCK_TYPE)) {
        return undefined;
      }

      var entity = (0, _draftHelpers.getDefaultEntity)(currentBlock, props.getEditorState().getCurrentContent().getEntity);

      if (entity && entity.getType() === ENTITY_KEY) {
        return {
          component: _SubmitQuestionBlock.default,
          editable: false,
          props: {
            submission: submission,
            associations: associations,
            enabledAssociations: enabledAssociations,
            questionsMap: questionsMap,
            properties: properties,
            sourceObjectType: sourceObjectType,
            sourceObject: sourceObject,
            onObjectPropertyChanged: onObjectPropertyChanged,
            onSubmissionChanged: onSubmissionChanged,
            getQuestionAndAnswerEnabled: getQuestionAndAnswerEnabled
          }
        };
      }

      return undefined;
    };
  };

  var entityToHTML = function entityToHTML(_ref2) {
    var data = _ref2.data,
        type = _ref2.type;
    var questionId = data.questionId;

    if (type !== ENTITY_KEY || !questionId) {
      return undefined;
    }

    return (0, _QuestionAndAnswerNote.default)({
      question: new _QuestionEntityRecord.default((0, _immutable.fromJS)(data)),
      properties: properties
    });
  };

  return (0, _draftExtend.createPlugin)({
    displayName: DISPLAY_NAME,
    blockRendererFn: blockRendererFn(options),
    entityToHTML: entityToHTML
  });
};

exports.default = _default;
module.exports = exports.default;